import { combineReducers } from "redux";
import appInfoReducer from "./appName/appNameReducer";
import productNCartReducer from "./productsNCart/reducer";

export const rootReducer = combineReducers({
    appInfo: appInfoReducer,
    productsNCart: productNCartReducer,
})